export default {
  MINIMIZE_BUTTON: "MINIMIZE_BUTTON",
  FAB_BUTTON: "FAB_BUTTON",
  CLIENT_BUTTON: "CLIENT_BUTTON",
  ESC_CLICK: "ESC_CLICK",
  PROMPT_SUGGESTION_CLICK: "PROMPT_SUGGESTION_CLICK",
  EXTERNAL_SEARCH: "EXTERNAL_SEARCH",
};
